import React from 'react';
import { array, bool } from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from '@fiverr-private/fiverr_context';
import FakeRadio from '../FakeRadio';
import { formatDaysKey } from '../../../utils/packagesUtils';

const renderPackageDeliveryTime = ({ extraFast, duration: days, packageId }, showSelection) => {
    const shouldRenderSelection = extraFast && showSelection;

    return (
        <td key={packageId}>
            {shouldRenderSelection ?
                <FakeRadio packageId={packageId}/> :
                <>{days} <I18n k={formatDaysKey(days)}/></>
            }
        </td>
    );
};

const DeliveryTime = ({ deliveries, showSelection = true }) => (
    <tr className="delivery-time">
        <th><I18n k={'gig_page_perseus.packages_table.delivery_time'}/></th>
        {
            deliveries.map((delivery) => renderPackageDeliveryTime(delivery, showSelection))
        }
    </tr>
);

DeliveryTime.propTypes = {
    deliveries: array,
    showSelection: bool
};

const mapStateToProps = ({ packages }) => ({
    deliveries: packages.packageList.map((packageData) => {
        const { extraFast, duration, id } = packageData;

        return {
            extraFast,
            duration,
            packageId: id
        };
    })
});

export { DeliveryTime };
export default connect(mapStateToProps)(DeliveryTime);
